require("!!C:\\svn\\trunk\\node_modules\\script-loader\\addScript.js")(require("!!C:\\svn\\trunk\\node_modules\\raw-loader\\index.js!C:\\svn\\trunk\\node_modules\\uglify-loader\\index.js!C:\\svn\\trunk\\node_modules\\babel-loader\\lib\\index.js?{\"presets\":[\"react\",\"es2015\"],\"plugins\":[\"transform-class-properties\",\"transform-object-assign\"],\"compact\":false}!C:\\svn\\trunk\\client-side\\Chosen\\chosen.jquery.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./~/uglify-loader!./client-side/Chosen/chosen.jquery.js
// module id = 94
// module chunks = 0